import React from "react";
import { Link, Redirect } from "react-router-dom";
import axios from 'axios';
import heroimg from "../assets/images/Sign In/Hero-bg.jpg";
import btnsrow from "../assets/images/icons/button-arrow.svg";
import backimg from "../assets/images/Sign In/Back.png";
import toast from 'toasted-notes' 
import 'toasted-notes/src/styles.css';

class Signup extends React.Component {
  constructor() {
    super();
    this.state = {
      full_name: '',
      email: '',
      number: '',
      password: '',
      error: ''
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeFullName = this.handleChangeFullName.bind(this);
    this.handleChangeNumber = this.handleChangeNumber.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }

  handleChangeFullName(event) {
    this.setState({full_name: event.target.value});
  }

  handleChangeNumber(event) {
    this.setState({number: event.target.value});
  }

  handleChangeEmail(event) {
    this.setState({email: event.target.value});
  }

  handleChangePassword(event) {
    this.setState({password: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    
    axios.post(`${process.env.REACT_APP_API_URL}/users.json`, this.state)
      .then((response) => {
        const data = response.data;
        if(data.status === true) {
          sessionStorage.setItem('user', JSON.stringify(response.data.user));
          toast.notify('Sign up Successfull');          
          if(!sessionStorage.getItem('return-url')) {
            this.props.history.push('/');
          }
          else {
            this.props.history.push(sessionStorage.getItem('return-url'));
            sessionStorage.removeItem('return-url')
          }
        }
        else {
          this.setState({ error: data.message });
        }
      })
      .catch();
  }

  render() {
    return (
      <section id="signup-section" className="section fix signup-section">
        <div className="container-fluid">
          <Link className="back-img" to="/">
            <img src={backimg} alt="back arrow" />
          </Link>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12" id="signin_mob-padd">
              <div className="singin-pass-form-details">
                <h2 className="projetc_ttls">
                  <Link className="main_logohm" to="/">
                  EXCLUSIVE GULETS{" "}
                  </Link>
                </h2>
                <p className="title">Sign up</p>
                <h2 className="main-title">Manage account and more...</h2>
                <p className="subline-text">
                  Sign up below to create your account.
                </p>
                
                {this.state.error === '' ? '' : <p className="title">{this.state.error}</p>}
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Full name:</label>
                    <input
                      type="text"
                      className="form-control"
                      id="InputEmail1"
                      name="full_name"
                      aria-describedby="emailHelp"
                      placeholder="What's your full name?"
                      value={this.state.full_name}
                      onChange={this.handleChangeFullName}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Phone number:</label>
                    <input
                      type="text"
                      className="form-control"
                      id="InputEmail1"
                      name="number"
                      aria-describedby="emailHelp"
                      placeholder="Used for bookings only"
                      value={this.state.number}
                      onChange={this.handleChangeNumber}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Email:</label>
                    <input
                      type="email"
                      className="form-control"
                      id="InputEmail1"
                      name="email"
                      aria-describedby="emailHelp"
                      placeholder="Your@email.com"
                      value={this.state.email}
                      onChange={this.handleChangeEmail}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Password:</label>
                    <input
                      type="password"
                      className="form-control"
                      id="InputEmail1"
                      name="password"
                      aria-describedby="emailHelp"
                      placeholder="Enter 6 characters or more"
                      value={this.state.password}
                      onChange={this.handleChangePassword}
                      required
                    />
                  </div>
                  <div className="forget-btn-div">
                    <button type="submit" className="btn btn-theme btn-primary">
                      <span>Sign up</span>
                      <div className="button-arrow">
                        <img
                          src={btnsrow}
                          className="img-responsive"
                          alt="arrow"
                        />
                      </div>
                    </button>
                  </div>
                  <p className="creat-acc-link">
                    <Link className="creat_link" to="/signin">
                      Already have an account? sign in.
                    </Link>
                  </p>
                </form>
              </div>
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 no-padding"
              id="mobile_hidesignin"
            >
              <div className="rightside-image signin-right">
                <img
                  id="signimgs"
                  src={heroimg}
                  className="img-responsive sign_img"
                  alt="Hero BG"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Signup;
